import { BaseEnv } from '@iskytrip/sdk'
import { env } from '@src/env.config'

const baseEnvModel = new BaseEnv({ env })

/**
 * @desc 当前环境的BaseEnv实例
 */
export { baseEnvModel }

/**
 * @description 航班状态值枚举
 */
export const FLIGHT_STATE = {
	PLAN: { code: 1, desc: '计划' },
	DELAY: { code: 2, desc: '延误' },
	CANCEL: { code: 3, desc: '取消' },
	ALTN: { code: 4, desc: '备降' },
	RETURN: { code: 5, desc: '返航' },
	FLY: { code: 6, desc: '起飞' },
	ARR: { code: 7, desc: '到达' },
	ALTN_FLY: { code: 8, desc: '备降起飞' },
	ALTN_CANCEL: { code: 9, desc: '备降取消' },
	ALTN_ARR: { code: 10, desc: '备降到达' },
	RETURN_FLY: { code: 11, desc: '返航起飞' },
	RETURN_CANCEL: { code: 12, desc: '返航取消' },
	RETURN_ARR: { code: 13, desc: '返航到达' },
	ADVANCE_CANCEL: { code: 14, desc: '提前取消' },
	CIRCLING: { code: 15, desc: '正在盘旋' },
	CIRCLED: { code: 16, desc: '盘旋过' },
	RISING: { code: 17, desc: '正在上升' },
	START_CRUISING: { code: 18, desc: '开始巡航' },
	START_DROP: { code: 19, desc: '开始下降' },
	SOON_ARRIVE: { code: 20, desc: '即将到达' },
	CRASH: { code: 21, desc: '失事' },
	OUT_CONTACT: { code: 22, desc: '失联' },
}

/**
 * @description 航班状态值对应颜色枚举
 */
export const FLIGHT_STATE_CLR_ENUM = {
	//单色
	monochrome: {
		normal: '#1FCC58',
		delay: '#FFAA00',
		cancel: '#FF5040',
		unknown: '#222222',
	},

	//渐变
	gradient: {
		normal: ['#57D982', '#1FCC58'],
		delay: ['#FFAA00', '#FF9932'],
		cancel: ['#FF6060', '#FF5040'],
		unknown: ['#000000', '#000000'],
	},
}

/**
 * @description 机场状态状态值枚举
 */
export const AIRPORT_STATE = {
	UNKNOWN: { code: 0, desc: '未知' },
	NO_FLIGHT: { code: 1, desc: '无航班进出港' },
	NORMAL: { code: 2, desc: '正常' },
	LOW_DELAY: { code: 3, desc: '小面积延误' },
	HIGH_DELAY: { code: 4, desc: '大面积延误' },
}

/**
 * @description 机场状态状态值对应颜色枚举
 */
export const AIRPORT_STATE_CLR_ENUM = {
	//单色
	monochrome: {
		normal: '#1FCC58',
		defer: '#FFAA00',
		delay: '#FF5040',
		unknown: '#666666',
	},
}

/**
 * @description navBar头部高度
 */
export const HEADER_HEIGHT = 44

/**
 * @description 行程类型
 * @typedef {enum}
 */
export const TRAVEL_TYPE = {
	FLIGHT: 1, // 航班
	PICKUP: 4, // 虹桥6677
	LONGPARKING: 7, // 浦东长时停车
	VIPROOM: 9, // 贵宾休息室
	FASTSECURITY: 10, // 快速安检
	BATTERYCAR: 11, // 电瓶车
	LUGGAGE: 6, // 行李配送
}

/**
 * @desc 骨架屏主色
 * @type {string}
 * @exports {string}
 */
export const SKELETON_MAIN_COLOR = '#F0F2F5'
